import React, {useMemo} from "react";
import {Link} from "react-router-dom";
import objectPath from "object-path";
import {useHtmlClassService} from "../../_core/MetronicLayout";
import {useSelector} from "react-redux";

export function Brand() {
  const {user} = useSelector(state => state.auth);
  
  const uiService = useHtmlClassService();
  var type = 'Super Admin'
  if(user.admin_type==='SUPER_ADMIN') { type=  'Super Admin' }
  else if(user.admin_type==="ADMIN"){type="Admin"}
  else {type="Normal User"}

  const layoutProps = useMemo(() => {
    return {
      brandClasses: uiService.getClasses("brand", true),
      asideSelfMinimizeToggle: objectPath.get(
          uiService.config,
          "aside.self.minimize.toggle"
      ),
      headerLogo: uiService.getLogo(),
      headerStickyLogo: uiService.getStickyLogo()
    };
  }, [uiService]);

  return (
    <>
      {/* begin::Brand */}
      <div
          className={`brand flex-column-auto ${layoutProps.brandClasses}`}
          id="kt_brand"
      >
        {/* begin::Logo */}
        
        <Link to={`/app/user/view/${user.user_id}`} className="py-2">
          {/* <img alt="logo" src={layoutProps.headerLogo}/> */}
          <h5 className="mb-0">{user.first_name+" "+user.last_name}</h5>
          <p className="mb-0">{type}</p>
        </Link>
        
        {/* end::Logo */}

        {layoutProps.asideSelfMinimizeToggle && (
          <>
            {/* begin::Toggle */}
            {/* <button className="brand-toggle btn btn-sm px-0" id="kt_aside_toggle">
              <span className="svg-icon svg-icon-xl">
                  <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Angle-double-left.svg")}/>
              </span>
            </button> */}
            {/* end::Toolbar */}
          </>
        )}

      </div>
      {/* end::Brand */}
      </>
  );
}
